import * as Updates from 'expo-updates';
import { EventBus } from "../EventBus";
import { showToastMessage } from "../toastMessage";
import { isWEB } from "../helpers/getPlatformType";
import {disconnectSoketi} from "../soketi";

const restartApp = async () => {
    console.log('RESTART_APP - App restart requested via Soketi event');
    showToastMessage('Restarting app...', 2000);
    
    setTimeout(async () => {
        if (isWEB()) {
            console.log('RESTART_APP - Reloading web app');
            await disconnectSoketi();
            window.location.reload();
            return;
        }
        
        if (!Updates.isEnabled) {
            console.warn('RESTART_APP - Updates not enabled, cannot restart app');
            showToastMessage('Cannot restart app - updates not enabled', 3000);
            return;
        }
        
        try {
            console.log('RESTART_APP - Calling Updates.reloadAsync()');
            await Updates.reloadAsync();
        } catch (error) {
            console.error('RESTART_APP - Failed to restart app:', error);
            showToastMessage('Failed to restart app', 3000);
        }
    }, 2000);
};

EventBus.on('restartApp', restartApp);
